import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { BehaviorSubject, Observable, shareReplay, Subject, switchMap, take, tap } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { LearningFilter } from '@shared/entities/learningFilter';
import { LearningFilterURL } from './learning.service';
import { LanguageService } from '@shared/services';

const LOG_PREFIX = '[Api][LearningFilters] ';

@Injectable({
  providedIn: 'root'
})
export class LearningFiltersService extends ApiService<LearningFilter> {
  private _refresh$: Subject<boolean>;
  all$: Observable<LearningFilter>;

  set filters(value: LearningFilterURL) {
    this.refresh(true);
  }

  constructor(private activatedRoute: ActivatedRoute, private languageService: LanguageService) {
    const masterUrl = '/learning/filters';
    const detailUrl = '/learning/filters';

    super(LearningFilter, masterUrl, detailUrl);

    this._refresh$ = new BehaviorSubject<boolean>(true);

    this.all$ = this._refresh$.pipe(
      switchMap(() => {
        // Aggiungi sempre il parametro language in maiuscolo
        const currentLanguage = this.languageService.getCurrent().toUpperCase();
        this.setUrlParameter('language', currentLanguage);

        const { locationId } = this.activatedRoute.snapshot.queryParams;
        if (locationId) {
          this.setUrlParameter('locationId', locationId);
        }
        return this.findOne('');
      }),
      tap({
        next: (result) => this.logger.debug(LOG_PREFIX + 'all$', result),
        error: (err) => this.logger.error(LOG_PREFIX + 'all$ error', err)
      }),
      shareReplay(1)
    );
  }

  refresh(value: boolean) {
    this.logger.debug(LOG_PREFIX + 'refresh');
    this._refresh$.next(value);

    return this.all$.pipe(take(1));
  }
}
